import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {Dialog} from '../luci-dialog/luci-dialog.model';
import {FreezeColumn, HeaderFreezeModel} from './luci-personalization-table-columns.interface';
import {ITableHeader} from '../luci-table/luci-table.model';

@Component({
  selector: 'luci-personalization-table-columns',
  templateUrl: './luci-personalization-table-columns.component.html',
  styleUrls: ['./luci-personalization-table-columns.component.scss']
})
export class LuciPersonalizationTableColumnsComponent implements OnInit, OnChanges {
  @Input() isColumnSettingsOpen = false;
  @Input() dialog: Dialog;
  @Input() ownTemplate = true;
  @Input() defaultFooter = false;
  @Input() tableSettingHeader: ITableHeader[] = [];
  @Input() isFreezeColumn = false;
  @Input() resetBtnText = 'Reset';
  @Input() applyBtnText = 'Apply';
  @Input() isApplyBtnPrimary = true;
  @Input() isResetBtnPrimary = false;
  @Input() isDataFetchFromServer = false;
  @Input() isDataFetchedFromServer: any;
  @Output() closeSettings: EventEmitter<any> = new EventEmitter();
  @Output() resetSettings: EventEmitter<any> = new EventEmitter();


  public availableList: ITableHeader[] = [];
  public selectedList: ITableHeader[] = [];
  public expandList: ITableHeader[] = [];
  public minSelectValue = 3;
  public disabledList = {
    selectedCheckbox: false,
    availableCheckbox: false,
    upBtn: false,
    downBtn: false
  };
  public freezeColumn: HeaderFreezeModel  = FreezeColumn;

  collapseBtn = 'collapse';
  expandBtn = 'expand';
  errorMessage  = '';

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isColumnSettingsOpen) {
      this.reset();
      this.setDefaultSettings();
    }
    if (changes.isDataFetchedFromServer && changes.isDataFetchedFromServer.currentValue) {
      if (changes.isDataFetchedFromServer.currentValue.PesonalizationColumn &&
        changes.isDataFetchedFromServer.currentValue.PesonalizationColumn.error){
        this.errorMessage =  changes.isDataFetchedFromServer.currentValue.PesonalizationColumn.errorMessage;
      }
      if (changes.isDataFetchedFromServer.currentValue.PesonalizationColumnReset) {
        if (changes.isDataFetchedFromServer.currentValue.PesonalizationColumnReset.error) {
          this.errorMessage = changes.isDataFetchedFromServer.currentValue.PesonalizationColumnReset.errorMessage;
        }
      }
    }

    if (changes.tableSettingHeader) {
      this.setDefaultSettings();
    }
  }

  setDefaultSettings() {
    let availableArr = this.tableSettingHeader.filter(t => (t.headerDefault && !t.headerDisplay));
    const selectArr = this.tableSettingHeader.filter(t => t.headerDisplay);
    availableArr = availableArr.sort((col: any, col1: any) => {
      return  col.name < col1.name ? -1 : 1;
    }) ;
    if (selectArr.length <= this.minSelectValue) {
      selectArr.forEach((item: any) => {
        item.disabled = true;
      });
    }
    this.selectedList = this.prepareCheckBoxList(selectArr);
    this.availableList = this.prepareCheckBoxList(availableArr);
  }

  prepareCheckBoxList(listData: any) {
    const newlist = [];
    listData.forEach(items => {
      newlist.push(Object.assign({}, items));
    });
    return newlist;
  }

  // Toggle data from right side list to left side list and viz.
  toggleListItems(params: string) {
    let checkListItems;
    if (params === 'select') {
      if (this.availableList.length > 0) {
        checkListItems = this.availableList.filter((x: any) => x.checked);
        this.selectedList.push(...checkListItems);
        this.availableList = this.availableList.filter((x: any) => !x.checked);
      }
    } else if (params === 'available') {
      if (this.selectedList.length > 0) {
        checkListItems = this.selectedList.filter((x: any) => x.checked);
        this.availableList.push(...checkListItems);
        this.selectedList = this.selectedList.filter((x: any) => !x.checked);
      }
    }
    this.toggleButtonState();
  }

  // Toggle selection of list items in the selected list
  toggleSelection(evt: any, name: string) {
    if (name === 'selected') {
      // const currentIndex = this.selectedList.findIndex((item) => item.key === evt.key );
      const uncheckedItems = this.selectedList.filter((item: any) => {
        return !item.checked;
      });
      this.toggleButtonState();
      if (uncheckedItems.length <= this.minSelectValue) {
        this.selectedList.forEach((item: any) => {
          item.disabled = (!item.checked);
        });
      } else {
        this.selectedList.forEach((item: any) => {
          item.disabled = false;
        });
      }
    }
  }

  getIndexOfCheckedList(list: any) {
    const indexList = [];
    list.forEach((val: any) => {
      if (val.checked) {
        indexList.push(list.indexOf(val));
      }
    });
    return indexList;
  }

  // Enable/Disable Up/Down Button.
  toggleButtonState(): void {
    const index = this.getIndexOfCheckedList(this.selectedList);
    const firstIndex = index.find(x => x === 0);
    const lastIndex = index.find(x => x === this.selectedList.length - 1);
    this.disabledList.upBtn = (firstIndex === 0);
    this.disabledList.downBtn = (lastIndex === this.selectedList.length - 1);
  }

  toggleListOrder(direction: string) {
    const index = this.getIndexOfCheckedList(this.selectedList);
    const changedList = this.switchPosition(this.selectedList, index, direction);
  }

  switchPosition(list: any, index: any, order: string) {
    const indexes = (order === 'down') ? index.reverse() : index;
    const changeList = list;
    if (order === 'up' && !this.disabledList.upBtn) {
      indexes.forEach(i => {
        [changeList[i], changeList[i - 1]] = [changeList[i - 1], changeList[i]];
      });
    } else if (order === 'down' && !this.disabledList.downBtn) {
      indexes.forEach(i => {
        [changeList[i], changeList[i + 1]] = [changeList[i + 1], changeList[i]];
      });
    }
    this.toggleButtonState();
    return changeList;
  }

  resetToDefault() {
    if (this.isDataFetchFromServer) {
      this.resetSettings.emit();
    } else {
      const resetList = this.resetData();
      if (resetList.length > 0) {
        this.availableList = [];
        this.selectedList = resetList;
      }
    }
  }

  resetData() {
    this.selectedList.forEach((item: any) => {
      item.disabled = false;
      item.checked = false;
    });
    this.availableList.forEach((item: any) => {
      item.disabled = false;
      item.checked = false;
      item.headerDisplay = true;
    });
    const reorderList = [...this.selectedList, ...this.availableList].sort((a: any, b: any) => {
      return a.id - b.id;
    });
    return reorderList.filter(x => x.headerDefault && x.headerDisplay);
  }

  saveConfiguration() {
    this.selectedList.forEach(l => l.headerDisplay = true);
    this.availableList.forEach(l => l.headerDisplay = false);
    const mergeList = [...this.selectedList, ...this.availableList];
    let fKey = null;
    let  fIndex = null;
    mergeList.forEach((item: any, index) => {
      item.position = index + 1;
      item.checked = false;
      fIndex = (index === 0) ? index : fIndex ;
      fKey = (fKey) ? fKey : item.key;
    });

    const newHeader = [...mergeList, ...this.expandList];
    this.closeSettings.emit({headers: newHeader, isFreeze: this.freezeColumn.checked, key: fKey, index: fIndex});
  }

  closeDialog(evt) {
    this.closeSettings.emit(false);
  }

  reset() {
    this.freezeColumn = FreezeColumn;
  }
}
